import { render, staticRenderFns } from "./AttributeEditFragment.vue?vue&type=template&id=439fc066&scoped=true"
import script from "./AttributeEditFragment.vue?vue&type=script&lang=js"
export * from "./AttributeEditFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439fc066",
  null
  
)

export default component.exports